import {IDefaultVOption} from "../interfaces/vSelectInterfaces";
import {DatetimeComparison} from "../models/conditionalRules/datetimeComparison";
import {DurationUnit} from "../../common/enums/durationUnit";
import {
  StatusActivationEventType,
  StatusActivationType,
} from "../../common/enums/statusActivationType";

export const statusActivationEventVOptions: IDefaultVOption<StatusActivationEventType>[] = [
  {label: 'Date Of Award', value: StatusActivationEventType.dateOfAward},
  {label: 'Date Of Expiration', value: StatusActivationEventType.dateOfExpiration},
];

export const statusActivationDateComparisonVOptions: IDefaultVOption<DatetimeComparison>[] = [
  {label: 'Before', value: DatetimeComparison.isBefore},
  {label: 'After', value: DatetimeComparison.isAfter},
];

export const statusActivationAfterTimeIntervalUnitVOptions: IDefaultVOption<DurationUnit>[] = [
  {label: 'Hours', value: DurationUnit.hour},
  {label: 'Days', value: DurationUnit.day},
  {label: 'Weeks', value: DurationUnit.week},
  {label: 'Months', value: DurationUnit.month},
  {label: 'Years', value: DurationUnit.year},
];

export const statusActivationRelativeDateUnitVOptions: IDefaultVOption<DurationUnit>[] = [
  {label: 'Hours', value: DurationUnit.hour},
  {label: 'Days', value: DurationUnit.day},
  {label: 'Weeks', value: DurationUnit.week},
  {label: 'Months', value: DurationUnit.month},
];

export const statusActivationVOptions: IDefaultVOption<StatusActivationType>[] = [
  {label: 'Immediately', value: StatusActivationType.immediately},
  {label: 'On Date', value: StatusActivationType.onDate},
  {label: 'After Time Interval', value: StatusActivationType.afterTimeInterval},
  {label: 'Relative Date', value: StatusActivationType.relativeDate},
  {label: 'Formula', value: StatusActivationType.formula}
];
